export default function ZonePerformancePage() {
  return (
    <section>
      <div className="page-header">
        <h1>Zone performance</h1>
        <p className="page-header__sub">30-day trend — aggregates only</p>
      </div>
      <p className="scaffold-note">Zone performance for area general managers. Detailed zone-level metrics are available in the next pilot phase.</p>
    </section>
  );
}
